export default "__VITE_ASSET__rjp7UgIY__"